export default __webpack_public_path__ + "static/media/icons-phone.fe0975f2.svg";